import type { AssetDomain } from '@/api/type-response'

function hostOf(value: string): string {
  try {
    return new URL(value.includes('://') ? value : `https://${value}`).hostname.toLowerCase()
  } catch {
    return ''
  }
}

export function findModelRouteTransferTarget(
  domains: AssetDomain[],
  keyword: string,
): AssetDomain | null {
  const target = keyword.trim()
  if (!target) return null

  const matches = domains.filter(
    (domain) =>
      !!domain.alias.trim() &&
      (domain.alias.trim() === target || hostOf(domain.hostname) === target.toLowerCase()),
  )

  // Never choose a transfer recipient by list order when the match is ambiguous.
  return matches.length === 1 ? matches[0] : null
}
